import { IntegerTranslator, ColorCodeTranslator, StringTranslator } from "./values";

export abstract class AbstractTranslator<TEntity, TBean> {
  protected readonly integer = new IntegerTranslator();
  protected readonly string = new StringTranslator();
  protected readonly colorCode = new ColorCodeTranslator();
}
